import React from 'react'
import { useAuth } from '@/lib/AuthContext'
import { Button } from '@/components/ui/button'
import { Zap, CreditCard } from 'lucide-react'

export default function CreditsBanner({ onSignIn }) {
  const { user, buyCredits } = useAuth();

  const isLoggedIn = !!user;
  const isPaid = user?.is_paid || false;
  const isFreeTier = !isLoggedIn || !isPaid;
  const generationsUsed = user?.free_generations_used || 0;
  const creditsCents = user?.credits_balance_cents || 0;

  const freeLimitReached = isFreeTier && generationsUsed >= 3;
  const paidNoCredits = isPaid && creditsCents <= 0;
  const paidLowBalance = isPaid && creditsCents > 0 && creditsCents < 100;

  if (!freeLimitReached && !paidNoCredits && !paidLowBalance) {
    return null;
  }

  let message = '';
  if (freeLimitReached) {
    message = "You've used all 3 free generations. Buy credits to continue.";
  } else if (paidNoCredits) {
    message = "No credits remaining.";
  } else if (paidLowBalance) {
    message = `Low balance: $${(creditsCents / 100).toFixed(2)} remaining.`;
  }

  const handleBuy = (amount) => {
    if (!isLoggedIn) {
      onSignIn();
    } else {
      buyCredits(amount);
    }
  };

  return (
    <div
      className="border rounded-lg p-4 text-center space-y-3"
      style={{ backgroundColor: 'var(--sdb-surface)', borderColor: 'var(--sdb-border)' }}
    >
      <div className="flex items-center justify-center gap-2 font-mono" style={{ color: 'var(--sdb-text)' }}>
        <Zap className="w-4 h-4" style={{ color: 'var(--sdb-accent)' }} />
        <span>{message}</span>
      </div>

      {freeLimitReached && !isLoggedIn && (
        <button
          className="gradient-bg glow-btn text-white font-mono px-6 py-2 rounded-lg"
          onClick={onSignIn}
        >
          Sign In
        </button>
      )}

      <div className="flex items-center justify-center gap-2">
        <CreditCard className="w-4 h-4" style={{ color: 'var(--sdb-text-muted)' }} />
        <Button
          variant="outline"
          size="sm"
          className="font-mono"
          style={{ borderColor: 'var(--sdb-border)', color: 'var(--sdb-text)' }}
          onClick={() => handleBuy(500)}
        >
          $5
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="font-mono"
          style={{ borderColor: 'var(--sdb-border)', color: 'var(--sdb-text)' }}
          onClick={() => handleBuy(1000)}
        >
          $10
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="font-mono"
          style={{ borderColor: 'var(--sdb-border)', color: 'var(--sdb-text)' }}
          onClick={() => handleBuy(2500)}
        >
          $25
        </Button>
      </div>
    </div>
  );
}
